import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: auto;\n\tmax-width: 100%;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { styled } from '@wp-g2/styles';
export var ImageView = styled.img(_templateObject());